export default __webpack_public_path__ + "static/media/nph.b906ca26.png";